// @flow strict

import React from 'react';
import { graphql, Link, useStaticQuery } from 'gatsby';

import { useLanguageContext } from '~contexts/language-context';

import type { Alternates } from '~types/post';

import * as styles from './mobile-language-switch.module.less';

/**
 * Type of component properties.
 */
type MobileLanguageSwitchProps = {
  alternates: Alternates,
};

export const MobileLanguageSwitch = ({
  alternates,
}: MobileLanguageSwitchProps) => {
  // get domains for each language
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          domain
        }
      }
    }
  `);

  const { language, languages } = useLanguageContext();

  // turn array into object with language code index
  const domain = data.site.siteMetadata.domain;

  return (
    <div className={styles.mobileLanguageSwitch}>
      {languages.map((lang) => {
        if (language === lang) {
          return (
            <div
              className={`${styles.mobileLanguageSwitchItem} ${styles.active}`}
            >
              {lang}
            </div>
          );
        }

        let href = alternates[lang];
        // if site does not have an alternate url
        // check if there is a fallback being passed
        if (href == null) {
          href = alternates.fallback[lang] || '/';
        }

        return (
          <Link
            to={href}
            className={styles.mobileLanguageSwitchItem}
            key={lang}
          >
            {lang}
          </Link>
        );
      })}
    </div>
  );
};
